/**
 * "Get this report by email" modal — captures a work email and queues
 * the per-process simulation summary for delivery. Engine
 * (`lib/pilot/email.ts`) drives the success-state toggle on
 * `#email-modal-success`. Every `id` preserved verbatim.
 *
 * Split out of PilotBody.tsx in F18 of the Oatmeal rebuild (see
 * `docs/eng/pilot-oatmeal-rebuild.md`).
 */

import React from 'react';
import {Button} from '../../oatmeal/elements/button';
import {Modal} from './_helpers';

export default function PilotEmailModal() {
  return (
    <Modal id="email-modal" width="narrow">
      <div className="modal-head flex items-center justify-between border-b border-taupe-200 px-6 py-4 dark:border-taupe-800">
        <h3 className="font-display text-2xl/8 text-taupe-950 dark:text-white">
          Get this report by email
        </h3>
        <button
          className="modal-close inline-flex size-9 items-center justify-center rounded-full text-taupe-700 hover:bg-taupe-100 dark:text-taupe-300 dark:hover:bg-taupe-800"
          id="email-modal-close"
          aria-label="Close"
        >
          ×
        </button>
      </div>
      <div className="modal-body flex flex-col gap-4 px-6 py-5" id="email-modal-body">
        <p className="email-modal-intro text-sm/6 text-taupe-700 dark:text-taupe-400">
          Drop your work email and we'll send the full simulation (numbers,
          assumptions, and a one-page action plan) straight to your inbox.
        </p>
        <label className="modal-label flex flex-col gap-2 text-sm/6 font-medium text-taupe-950 dark:text-white">
          Work email
          <input
            type="email"
            id="email-modal-input"
            placeholder="you@company.com"
            autoComplete="email"
            className="rounded-lg border border-taupe-300 bg-white px-3 py-2 text-sm font-normal text-taupe-950 placeholder:text-taupe-500 focus:border-taupe-950 focus:outline-none focus:ring-2 focus:ring-taupe-300 dark:border-taupe-700 dark:bg-taupe-900 dark:text-white"
          />
        </label>
        <div
          className="modal-error min-h-[1.25rem] text-sm/5 text-red-700"
          id="email-modal-error"
        />
      </div>
      <div
        className="modal-body modal-body-success hidden flex-col items-center gap-3 px-6 py-8 text-center [&:not([hidden])]:flex"
        id="email-modal-success"
        hidden
      >
        <div className="email-success-icon inline-flex size-12 items-center justify-center rounded-full bg-taupe-100 text-2xl text-taupe-950 dark:bg-taupe-900 dark:text-white">
          ✓
        </div>
        <h4 className="email-success-title font-display text-xl/8 text-taupe-950 dark:text-white">
          On its way.
        </h4>
        <p
          className="email-success-body text-sm/6 text-taupe-700 dark:text-taupe-400"
          id="email-success-text"
        >
          —
        </p>
      </div>
      <div
        className="modal-foot flex items-center justify-end gap-3 border-t border-taupe-200 px-6 py-4 dark:border-taupe-800"
        id="email-modal-foot"
      >
        <Button className="btn-primary" id="email-modal-submit" size="lg">
          Send me the report
        </Button>
      </div>
    </Modal>
  );
}
